module.exports = __webpack_public_path__ + "img/face-smile-hearts-duotone.85a31a99.svg";